import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import type { StatusSolicitacao } from '../../../../../models';
import type { PontoFunilStatus } from '../solicitacoesDashboard.utils';

const COR_POR_STATUS: Record<StatusSolicitacao, string> = {
  aberta: '#EAB308',
  em_andamento: '#3B82F6',
  concluida: '#10B981',
  cancelada: '#9CA3AF',
  excluida: '#EF4444',
};

interface FunilStatusChartProps {
  dados: PontoFunilStatus[];
}

export default function FunilStatusChart({ dados }: FunilStatusChartProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <h3 className="mb-4 font-montserrat text-base font-semibold text-gray-900">Solicitações por Status</h3>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={dados}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="label" style={{ fontSize: '12px', fontFamily: 'Montserrat' }} stroke="#6b7280" />
          <YAxis allowDecimals={false} style={{ fontSize: '12px', fontFamily: 'Montserrat' }} stroke="#6b7280" />
          <Tooltip
            contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontFamily: 'Montserrat' }}
            formatter={(valor: number) => [valor, 'Solicitações']}
          />
          <Bar dataKey="quantidade" radius={[6, 6, 0, 0]}>
            {dados.map((ponto) => (
              <Cell key={ponto.status} fill={COR_POR_STATUS[ponto.status]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
